export var ChargeSplitMode;
(function (ChargeSplitMode) {
    ChargeSplitMode["Proportional"] = "PROPORTIONAL";
    ChargeSplitMode["Equal"] = "EQUAL";
})(ChargeSplitMode || (ChargeSplitMode = {}));
//# sourceMappingURL=charge-split-mode.enum.js.map